import { RecordingBase } from 'types/recordings';

import { GRAPH_BAR_WIDTH_IN_MS } from './waveInsightData';
import { BaseRewindPlaylistBlock, RewindError, RewindErrorType } from './playlistBlocks.types';

export interface TimeRange {
  start: Date;
  end: Date;
}

const compareTimesToNearestGraphBlock = (start: Date, end: Date) =>
  end.getTime() - start.getTime() > GRAPH_BAR_WIDTH_IN_MS;

export const findErrorsForGapsInRewinds = (
  rewinds: RecordingBase[],
  bucketStart: Date,
  bucketEnd: Date,
): RewindError[] => {
  const sortedRewinds = [...rewinds].sort(
    (a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime(),
  );

  const sortedRewindsTransformed = sortedRewinds.map(({ startDate, endDate }) => ({
    startDate: new Date(startDate),
    endDate: new Date(endDate),
  }));

  sortedRewindsTransformed.push({ startDate: bucketEnd, endDate: bucketEnd });

  return sortedRewindsTransformed.reduce((acc, current, index, array) => {
    const start = new Date(index === 0 ? bucketStart : array[index - 1].endDate);
    const end = new Date(current.startDate);
    if (compareTimesToNearestGraphBlock(start, end)) {
      acc.push({ type: RewindErrorType.NO_DATA, startDate: start, endDate: end });
    }
    return acc;
  }, [] as RewindError[]);
};

export const addMissingRewindsErrors = (
  playlistBlocks: Map<string, BaseRewindPlaylistBlock>,
): void => {
  playlistBlocks.forEach((playlistBlock, endTime) => {
    const updatedPlaylistBlock = {
      ...playlistBlock,
      errors: playlistBlock.errors.concat(
        findErrorsForGapsInRewinds(
          playlistBlock.rewinds,
          playlistBlock.bucketStart,
          playlistBlock.bucketEnd,
        ),
      ),
    };

    playlistBlocks.set(endTime, updatedPlaylistBlock);
  });
};
